var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 4,
    viewBox: "0 0 4 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_2311_17854",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1.1499,
    width: 6,
    height: 6,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: -1.1499,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.663 2.2491C0.663 1.8071 0.810333 1.43876 1.105 1.1441C1.40833 0.849431 1.78533 0.702097 2.236 0.702097C2.704 0.702097 3.081 0.849431 3.367 1.1441C3.653 1.43876 3.796 1.8071 3.796 2.2491C3.796 2.6911 3.653 3.05943 3.367 3.3541C3.081 3.6401 2.704 3.7831 2.236 3.7831C1.78533 3.7831 1.40833 3.6401 1.105 3.3541C0.810333 3.05943 0.663 2.6911 0.663 2.2491Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.663 2.2491C0.663 1.8071 0.810333 1.43876 1.105 1.1441C1.40833 0.849431 1.78533 0.702097 2.236 0.702097C2.704 0.702097 3.081 0.849431 3.367 1.1441C3.653 1.43876 3.796 1.8071 3.796 2.2491C3.796 2.6911 3.653 3.05943 3.367 3.3541C3.081 3.6401 2.704 3.7831 2.236 3.7831C1.78533 3.7831 1.40833 3.6401 1.105 3.3541C0.810333 3.05943 0.663 2.6911 0.663 2.2491Z",
    fill: "#1943DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.105 1.1441L0.408214 0.426818L0.403017 0.431867L0.397893 0.436991L1.105 1.1441ZM3.367 1.1441L2.64942 1.84057L2.64942 1.84057L3.367 1.1441ZM3.367 3.3541L4.07411 4.0612L4.07938 4.05593L4.08458 4.05057L3.367 3.3541ZM1.105 3.3541L0.397893 4.0612L0.40829 4.0716L0.418987 4.08169L1.105 3.3541ZM1.663 2.2491C1.663 2.05446 1.71724 1.94608 1.81211 1.8512L0.397893 0.436991C-0.0965689 0.931453 -0.337 1.55974 -0.337 2.2491H1.663ZM1.80179 1.86138C1.90538 1.76074 2.02668 1.7021 2.236 1.7021V-0.297903C1.54399 -0.297903 0.911284 -0.0618779 0.408214 0.426818L1.80179 1.86138ZM2.236 1.7021C2.47487 1.7021 2.57866 1.76767 2.64942 1.84057L4.08458 0.447622C3.58334 -0.0688126 2.93313 -0.297903 2.236 -0.297903V1.7021ZM2.64942 1.84057C2.73963 1.93352 2.796 2.0453 2.796 2.2491H4.796C4.796 1.5689 4.56637 0.944008 4.08458 0.447622L2.64942 1.84057ZM2.796 2.2491C2.796 2.4529 2.73963 2.56467 2.64942 2.65762L4.08458 4.05057C4.56637 3.55419 4.796 2.9293 4.796 2.2491H2.796ZM2.65989 2.64699C2.59108 2.71581 2.48388 2.7831 2.236 2.7831V4.7831C2.92412 4.7831 3.57092 4.56439 4.07411 4.0612L2.65989 2.64699ZM2.236 2.7831C2.01778 2.7831 1.89296 2.72263 1.79101 2.62651L0.418987 4.08169C0.923702 4.55756 1.55289 4.7831 2.236 4.7831V2.7831ZM1.81211 2.64699C1.71724 2.55212 1.663 2.44374 1.663 2.2491H-0.337C-0.337 2.93846 -0.0965689 3.56674 0.397893 4.0612L1.81211 2.64699Z",
    fill: "#CBD0FC",
    mask: "url(#path-1-outside-1_2311_17854)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.b22055bfcd4ed5a546e9dbd3d9880031.svg";
export { ForwardRef as ReactComponent };